import { SvgIcon, SvgIconProps } from "@mui/material";

export const TextV2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M6 6.5h12.005M12.002 18.505V6.5"
      />
    </svg>
  </SvgIcon>
);
